import { MaskedInput } from "@expert/common-ui";
import { Flex, Text } from "@mantine/core";
import type { GuideTextInput } from "../logic-builder";

interface GuideCardInputProps {
    textInput: GuideTextInput;
    value: string;
    onInput: (val: string) => void;
    validationError?: string;
}

export function GuideCardInput({ textInput, validationError, value, onInput }: GuideCardInputProps) {
    return (
        <Flex direction="column" w="100%">
            {validationError && (
                <Text size="xs" c="var(--mantine-color-red-text)">
                    {validationError}
                </Text>
            )}
            <MaskedInput
                value={value}
                onInput={(e) => onInput(e.currentTarget.value)}
                mask={textInput.mask}
                type={textInput.inputType}
                placeholder={textInput.placeholder}
                w="27.625rem"
                h="2.5rem"
                error={!!validationError}
                className="fs-mask"
            />
        </Flex>
    );
}
